import { render, staticRenderFns } from "./bin-management.vue?vue&type=template&id=635ea1bc&scoped=true&"
import script from "./js/bin-management.js?vue&type=script&lang=js&"
export * from "./js/bin-management.js?vue&type=script&lang=js&"
import style0 from "./bin-management.vue?vue&type=style&index=0&id=635ea1bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ea1bc",
  null
  
)

export default component.exports